import React, { Component, useRef } from 'react';
import { BrowserRouter, StaticRouter, Route, Redirect, NavLink, matchPath } from 'react-router-dom';
import { App as cApp } from '@capacitor/app';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import RouterOutlet from './components/RouterOutlet';
import BrowseAllBooks from './PageBrowseAllBooks';
import ReadingListSearch from './PageReadingListSearch';
import ExegesisSearch from './PageExegesisSearch';
import ContactUs from './PageContactUs';
import BibleReading from './PageBibleReading';
import Chat from './PageChat';
import Book from './PageBook';
import Sitemap from './PageSitemap';
import Home from './PageHome';
import HelpPage from './PageHelp'
import WebMcpSupport from './PageWebMcpSupport';
import Privacy from './PagePrivacy';
import PageBlank from './PageBlank';
import ExegesisResult from './PageExegesisResult';
import PeopleResult from './PagePeopleResult';
import PlaceResult from './PagePlacesResult';
import PageEntityDirectory from './PageEntityDirectory';
import EventPage from './PageEvent';
import CalorieCounter from './labs/Health/PageCalorieCounter';
import MealCounter from './labs/Health/PageMealCounter';
import Counter from './labs/Misc/PageCounter';
import DebugStorage from './labs/Misc/PageDebug';
import DeleteData from './labs/Misc/PageDeleteData';
import Weight from './labs/Health/PageWeight';
import Ingredient from './labs/Food/PageIngredient';
import Recipe from './labs/Food/PageRecipe';
import Labs from './PageLabs';
import Empty from './PageEmpty';
import Plans from './PagePlans';
import Verify from './PagePlansVerify';
import Unsubscribe from './PagePlansUnsubscribe';
import PagePlansGobacklink from './PagePlansGobacklink';
import './App.css';
import './bootstrap-4/css/bootstrap.css';
import logo from './images/aibiblelogo.png';
import { ThemeContext, themes } from './components/Core/ThemeContext';
import RouteChangeTracker from './RouteChangeTracker'
import { Capacitor } from '@capacitor/core';
import { SafeArea } from 'capacitor-plugin-safe-area';
import { ArrowRight } from '@material-ui/icons';
import { Map } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import MenuBook from '@material-ui/icons/MenuBook';
import CallSplitIcon from '@material-ui/icons/CallSplit';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import ListAltIcon from '@material-ui/icons/ListAlt';
import Search from '@material-ui/icons/Search';
import Help from '@material-ui/icons/Help';
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'
import { Network } from '@capacitor/network';
import * as Swetrix from 'swetrix'
import { trackCustomEvent } from './utilities/analytics';
import FlaskIcon from '@material-ui/icons/LocalHospital';
import { LocalNotifications } from '@capacitor/local-notifications';
import { registerPlugin } from '@capacitor/core';
import PageDebug from './labs/Misc/PageDebug';
import osisConverters from './utilities/osisConversions';
import { deriveLegacyCanonicalPath } from './utilities/canonicalUrls';
import PagePerspectivesHub from './PagePerspectivesHub';
import PagePerspective from './PagePerspective';
import PagePerspectiveChart from './PagePerspectiveChart';
var bcv_parser = require("bible-passage-reference-parser/js/en_bcv_parser").bcv_parser;
var bcv = new bcv_parser;

const MessagePlugin = registerPlugin('Message');

// Listen for notifications when the app is in the foreground
LocalNotifications.addListener('localNotificationReceived', (notification) => {
  console.log('Received notification:', notification);
  // Show a custom alert or update the UI as needed
});

// In case the app is in the background or terminated, handle notifications when resumed
LocalNotifications.addListener('localNotificationActionPerformed', (notification) => {
  console.log('Notification tapped:', notification);
});

//window.API_BASE = 'https://d2ec36mx9v0bh8.cloudfront.net';
window.API_BASE = 'https://5v7tx8iltj.execute-api.ap-southeast-2.amazonaws.com/Prod';

window.getVerseURL = (verse) => {
    const sanitizedVerse = osisConverters.sanitizeOsisRange(verse);
    return (window.web_version)?osisConverters.toWebReadPath(sanitizedVerse):`/reader?verse=${sanitizedVerse}`;
}

function validateParameters(str) {
    return str.replace(/[^a-zA-Z0-9:.\- ]/g, ""); // Removes all disallowed characters
}

window.messageSystem = (name, data) => {
    console.log('MessageSystem: ', name, data)

    if (name === "sharedMessage")
    {
        console.log("sharedMessage", JSON.parse(data))
    }
    else if (name === "deepLink")
    {
        console.log("deepLink", JSON.parse(data))
    }
    else if (name === "intentTrigger")
    {
        const message = JSON.parse(data);
        console.log("intentTrigger", message)

        if (message.units.toLowerCase() == 'calories')
        {
            window.location = '/labs/calories?calories=' + validateParameters(message.value + "")
        } 
        else if (message.units.toLowerCase() == 'kg')
        {
            if (message.value != "")
                window.location = '/labs/weight?weight=' + validateParameters(message.value + "");
            else
                window.location = '/labs/weight';
        } 
        else if (message.units.toLowerCase() == 'word.search')
        {
            window.location = '/search';
        }
        else if (message.units.toLowerCase() == 'verse')
        {
            let verse = validateParameters(message.value) + "";
            verse = verse.replaceAll(' one', '1');
            verse = verse.replaceAll(' two', '2');
            verse = verse.replaceAll(' three', '3');
            verse = verse.replaceAll(' four', '4');
            verse = verse.replaceAll(' five', '5');
            verse = verse.replaceAll(' six', '6');
            verse = verse.replaceAll(' seven', '7');
            verse = verse.replaceAll(' eight', '8');
            verse = verse.replaceAll(' nine', '9');

            console.log('message:', verse)

            const verseName = bcv.parse(verse).osis();

            console.log('Opening verse: ' + verseName)

            window.location = window.getVerseURL(verseName);
        } 
    }
}

// optional configuration
const options = {
  // you can also just use 'bottom center'
  position: positions.MIDDLE,
  timeout: 7000,
  offset: '30px',
  // you can also just use 'scale'
  transition: transitions.SCALE
}

const isPrerender = process.env.PRERENDER === 'true';
const web_version = isPrerender || (Capacitor.getPlatform()==='web');

window.web_version = web_version;
window.show_footer = true;

console.log('Platform: ' + Capacitor.getPlatform())

// const TRACKING_ID = "UA-138966130-2"; // YOUR_OWN_TRACKING_ID
// const MEASUREMENT_ID = "G-9GMZ38C5JB"; // GA4 Property ID
const PROJECT_ID = "frPSChzQBszC"; // Swetrix Project ID
const PROJECT_ID_ANDROID = "GRfVoFTuslGZ"; // Swetrix Project ID ANDROID
const PROJECT_ID_IOS = "jil1UKyHMq4Y"; // Swetrix Project ID IOS
const PROJECT_ID_LOCALHOST = "cVwz0CHOaWFL"

if (!process.env.TESTMODE && !isPrerender)
{
    console.log('Window location: ', window.location)
    if ((window.location + "").includes("localhost"))
    {
        console.log('Init Swetrix for localhost')
        Swetrix.init(PROJECT_ID_LOCALHOST)
    }
    else if (Capacitor.getPlatform()==='ios')
    {
        console.log('Init Swetrix for iOS');
        Swetrix.init(PROJECT_ID_IOS);
    }
    else if (Capacitor.getPlatform()==='android')
    {
        console.log('Init Swetrix for Android');
        Swetrix.init(PROJECT_ID_ANDROID);
    }
    else
    {
        console.log('Init Swetrix for Web');
        Swetrix.init(PROJECT_ID);
    }

    Swetrix.trackViews();

    // ReactGA.initialize(MEASUREMENT_ID, {
    //     gaOptions: {
    //         storeGac: false,
    //         anonymizeIp: true
    //     }
    // });    
}

const handleDeepLink = (event) => {
    console.log('DeepLink Received: ', event)
    const url = event.url;
    console.log('DeepLink Decoded: ', url)
    
    if (url) {
      // Strip the base URL from the incoming deep link URL
      const path = url.replace('ai-bible://', ''); // Replace 'myapp://' with your app's scheme
      
      // Automatically route to the corresponding path
      //this.props.history.push(path);
      window.location = "/" + path;
    }
  };

const messageListener = () => {
    console.log('adding general message listener')
    window.addEventListener('messageNotification', (event) => {
        const message = event.detail;  // This is the message from iOS
        console.log('Received message:', message);
    });
};

const messagePlugin = async () => {
    console.log('messagePlugin');
    const { value } = await Message.message({ value: 'Hello World!' });
    console.log('Response from native:', value);  
}

if (!isPrerender)
{
    messageListener();

    document.addEventListener('deviceready', () => {
        console.log('deviceReady');

        messagePlugin();

        cApp.addListener('appUrlOpen', (event) => {
            console.log('App opened with URL:', event.url);
            handleDeepLink(event);
        });

        Capacitor.addListener('appUrlOpen', (event) => {
            console.log('App opened with URL:', event.url);
            handleDeepLink(event);
        });

        cApp.addListener('appStateChange', ({ isActive }) => {
            console.log('App state changed. Is active?', isActive);
        });

        cApp.addListener('LabsIntentsExtension', (data) => {
        console.log('Received LabsIntentsExtension event:', data);
        });
        
        cApp.addListener('com.alistair.clarkson.aibible.customEvent', (data) => {
        console.log('Received custom event:', data);
        });

        Capacitor.addListener('com.alistair.clarkson.aibible.customEvent', (data) => {
            console.log('Received custom event:', data);
            });
        console.log('Added listeners');

        window.dispatchEvent(new CustomEvent('com.alistair.clarkson.aibible.customEvent', { detail: { key: 'test' } }));

        console.log('Sent test message');
    });

    const checkAppLaunchUrl = async () => {
        const { url } = await cApp.getLaunchUrl();
        console.log('React: App opened with URL: ' + url);
    };

    checkAppLaunchUrl();
}

const routes = [
    {
        path: '/',
        name: 'Browse',
        Component: BrowseAllBooks,
        mobile: true,
        TabIcon: MenuBook,
    }, {
        path: '/reader',
        hidden: true,
        // hidden: web_version,
        // mobile: true,
        name: 'Reader',
        Component: BibleReading,
        // TabIcon: MenuBook,
    },
    , {
        path: ['/read/:verse', '/read/:verse/'],
        hidden: true,
        // hidden: web_version,
        // mobile: true,
        name: 'Reader',
        Component: BibleReading,
        // TabIcon: MenuBook,
    }, 
    {
        path: '/search',
        name: 'Search',
        Component: ReadingListSearch,
        //hidden: true,
        // mobile: true,
        // TabIcon: Search,
    },
    {
        path: '/web-mcp-support',
        hidden: true,
        name: 'Web MCP Support',
        Component: WebMcpSupport,
    },
    {
        path: '/Chat',
        name: 'Chat',
        Component: Chat,
        hidden: true,
    },{
        path: '/exegesis',
        name: 'Exegesis',
        //Component: ExegesisSearch,
        Component: Chat,
        hidden: true
        // mobile: true,
        // TabIcon: FingerprintIcon,
    }, {
        path: '/labs/exegesis',
        name: 'Exegesis',
        Component: ExegesisSearch,
        hidden: true
        // mobile: true,
        // TabIcon: FingerprintIcon,
    },{
        path: '/privacy',
        name: 'Privacy',
        Component: Privacy,
    },{
        path: '/perspectives',
        name: 'Perspectives',
        Component: PagePerspectivesHub,
        mobile: true,
        TabIcon: CallSplitIcon,
    },{
        path: '/perspectives/chart',
        name: 'Relationship Map',
        Component: PagePerspectiveChart,
        hidden: true,
    },{
        path: '/perspectives/:slug',
        hidden: true,
        name: 'Perspectives',
        Component: PagePerspective,
    },{
        path: '/plans',
        name: 'Devotionals',
        mobileCompactName: 'Plans',
        Component: Plans,
        mobile: true,
        TabIcon: ListAltIcon
    },{
        path: '/plans/:dev',
        hidden: true,
        name: 'Devotionals',
        Component: Plans
    },{
        path: '/plans/verify',
        name: 'Verify',
        hidden: true,
        Component: Verify
    },{
        path: '/plans/unsubscribe',
        name: 'Unsubscribe',
        hidden: true,
        Component: Unsubscribe
    },{ 
        path: '/plans/goback',
        name: 'Goback',
        hidden: true,
        Component: PagePlansGobacklink
    },{
        path: '/help',
        hidden: false,
        name: 'Help',
        Component: HelpPage,
    },{
        path: '/labs',
        hidden: false,
        name: 'Tools',
        Component: Labs,
        TabIcon: FlaskIcon,
        mobile: true
    }
    , {
        path: '/contact',
        name: 'Contact',
        Component: ContactUs,
    }, {
        path: '/exegete',
        hidden: true,
        name: 'ExegesisResult',
        //Component: ExegesisResult,
        Component: Chat,
    }, {
        path: '/people',
        hidden: true,
        name: 'PeopleResult',
        Component: () => (new URLSearchParams(window.location.search).get('rec')
            ? <PeopleResult />
            : <PageEntityDirectory type="people" />),
    }, {
        path: '/person/:person',
        hidden: true,
        name: 'PeopleResult',
        Component: PeopleResult,
    }, {
        path: '/places',
        hidden: true,
        name: 'PlaceResult',
        Component: () => (new URLSearchParams(window.location.search).get('rec')
            ? <PlaceResult />
            : <PageEntityDirectory type="places" />),
    }, {
        path: ['/location', '/locations'],
        hidden: true,
        name: 'PlacesRedirect',
        Component: () => <Redirect to="/places" />,
    }, {
        path: '/location/:place',
        hidden: true,
        name: 'PlaceResult',
        Component: PlaceResult,
    }, {
        path: '/event/:event',
        hidden: true,
        name: 'Event',
        Component: EventPage,
    }, {
        path: '/book/:ref',
        hidden: true,
        name: 'Book',
        Component: Book,
    }, {
        path: '/book',
        hidden: true,
        name: 'Book',
        Component: Book,
    }, {
        path: '/sitemap',
        hidden: true,
        name: 'Sitemap',
        Component: Sitemap,
    }, {
        path: '/empty',
        hidden: true,
        name: 'Empty',
        Component: Empty,
    },
    {
        path: '/labs/debug',
        hidden: true,
        name: 'Debug',
        Component: DebugStorage,
    },
    {
        path: '/labs/weight',
        hidden: true,
        name: 'Weight',
        Component: Weight,
    },{
        path: '/labs/calories',
        hidden: true,
        name: 'CalorieCounter',
        Component: CalorieCounter,
    },{
        path: '/labs/meals',
        hidden: true,
        name: 'MealCounter',
        Component: MealCounter,
    } 
    ,{
        path: '/labs/counter',
        hidden: true,
        name: 'Counter',
        Component: Counter,
    }, 
    ,{
        path: '/labs/ingredient',
        hidden: true,
        name: 'Ingredient',
        Component: Ingredient,
    }, {
        path: '/labs/recipe',
        hidden: true,
        name: 'Recipe',
        Component: Recipe,
    }, {
        path: '/labs/deleteData',
        hidden: true,
        name: 'DeleteData',
        Component: DeleteData,
    }, 
];

class App extends Component {
    state = {
        contacts: [],
        expanded: false,
        loading: true,
        path: '/',
        menuBarHeight: 78,
        spacerHeight: 78,
        insets: {
            bottom:0,
            left:0,
            right:0,
            top:0
        }
    }

    fixedMenuBarRef = React.createRef();

    spacerRef = React.createRef();

    constructor() {
        super();
        this.toggle = this.toggle.bind(this);
        this.setLoading = this.setLoading.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.setInsets();
        document.body.style.backgroundColor = '#fdfdff';
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    setInsets() {
        SafeArea.getSafeAreaInsets().then(({ insets }) => {
            this.setState({insets});
        });
    }

    setLoading(loading) {
        this.setState({ loading });
    }

    navLinkHandleClick() {
        console.log('Clicked');
        this.setLoading(true);
    }

    componentDidMount() {
        trackCustomEvent({
            ev: `app.mount.unique`,
            unique: true,
        }, {
            automatic: true,
        })

        console.log('App componentDidMount');
        if (window.web_version) {
            const shouldNormalizeLegacyPath =
                window.location.pathname.startsWith('/Plans')
                || window.location.pathname.startsWith('/Privacy');
            const normalizedPath = shouldNormalizeLegacyPath
                ? deriveLegacyCanonicalPath(window.location.pathname, window.location.search)
                : null;
            if (normalizedPath && `${window.location.pathname}${window.location.search}` !== normalizedPath) {
                window.history.replaceState({}, '', normalizedPath);
            }
        }
        this.setInsets();
        //console.log('insets', this.state.insets);
        window.addEventListener('resize', this.handleResize);
        this.handleResize(); 
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        console.log('Removing appUrlOpen listener...');
        cApp.removeListener('appUrlOpen', handleDeepLink);
    }

    handleResize() {
        let newHeight = this.fixedMenuBarRef?.current?.getBoundingClientRect().height;
        if (newHeight > 90) newHeight = 84; // Hard fix this, no idea why this is 386 sometimes on safari

        this.setState({
            menuBarHeight: newHeight,
            spacerHeight: this.spacerRef?.current?.getBoundingClientRect().height
        }, ()=> {
            
        })

        //console.log("resize", this.state.menuBarHeight, newHeight);

        this.setInsets();
    }

    toggle() {
        console.log('Navbar Toggled');
        this.setState((state, props) => ({ expanded: !state.expanded }));
    }

    render() {
        const theme = createTheme({
            typography: {
                fontFamily: ['Pontano+Sans', 'Montserrat', 'Titillium Web', 'Roboto', 'Helvetica Neue', 'Arial', 'sans-serif'].join(','),
            },
        });

        themes.light.loading = this.setLoading;
        themes.dark.loading = this.setLoading;
        const currentPrerenderPath = window.__PRERENDER_PATHNAME || window.location.pathname;
        const Router = isPrerender ? StaticRouter : BrowserRouter;
        const routerProps = isPrerender
            ? { location: currentPrerenderPath + window.location.search, context: {} }
            : {};
        const prerenderRoute = isPrerender
            ? routes.filter(Boolean).find((route) => matchPath(currentPrerenderPath, {
                path: route.path,
                exact: true,
                sensitive: true,
            }))
            : null;

        // this.handleResize();
        // const bounds = this.fixedMenuBarRef?.current?.getBoundingClientRect();

        //console.log('fixedMenuBar', this.state.menuBarHeight, this.state.spacerHeight);

        return (
            <div style={{ position: 'relative' }}>
                <AlertProvider template={AlertTemplate} {...options}>
                <div>
                    <ThemeContext.Provider value={themes.light}>
                        <ThemeProvider theme={theme}>
                            <Router {...routerProps}>
                                <RouteChangeTracker/>
                                {
                                    // Change NavBar configuration based on whether it is a mobile or web platform
                                    (window.web_version)?
                                        <>
                                            <Navbar
                                            className="color-nav"
                                            style={{
                                                paddingLeft: 12, paddingRight: 12, paddingTop: 0, paddingBottom: 8, minHeight: 78
                                            }}
                                            bg="light"
                                            expand="lg"
                                            fixed="top"
                                            
                                            onToggle={this.toggle.bind(this)}
                                            expanded={this.state.expanded}
                                            ref={this.fixedMenuBarRef}
                                            >
                                            <Navbar.Brand
                                                href="/"
                                                className="navbarbranding"
                                                onClick={(event) => {
                                                    event.preventDefault();
                                                    window.location.assign('/');
                                                }}
                                            >
                                                <img src={logo} alt="ai-BIBLE" className="navbarlogo ml-2" />
                                            </Navbar.Brand>

                                            <Navbar.Collapse id="basic-navbar-nav ml-auto">
                                                <Nav className="ml-auto">
                                                    {routes.map((route, index) => ((route.hidden !== true) && (
                                                        <div key={index}>
                                                            <Nav.Link
                                                                as={NavLink}
                                                                to={route.path}
                                                                className="titletext"
                                                                activeClassName="active"
                                                                isActive={(match, location) => (
                                                                    route.path === '/perspectives'
                                                                        ? location.pathname.startsWith('/perspectives')
                                                                        : location.pathname === route.path
                                                                )}
                                                                onClick={
                                                                    () => {
                                                                        if (route.path !== this.state.path) {
                                                                            trackCustomEvent({
                                                                                ev: `nav.click.web.${route.path}`,
                                                                                unique: false,
                                                                            })
                                                                            this.setState({ path: route.path, expanded: !this.state.expanded });
                                                                            this.navLinkHandleClick.bind(this);
                                                                        }
                                                                    }
                                                                }
                                                                exact
                                                            >
                                                                {route.name}
                                                            </Nav.Link>
                                                        </div>
                                                    )))}
                                                </Nav>
                                            </Navbar.Collapse>

                                            <div className="navbartogglezone">
                                                <Navbar.Toggle />
                                                <img src={logo} alt="ai-BIBLE" className="navbarlogo2" />
                                            </div>

                                        </Navbar>
                                        <div className="navbarheightguess" style={{height:this.state.menuBarHeight}} ref={this.spacerRef}></div>
                                    </>:
                                    <>
                                        {window.show_footer?<>
                                        <div className="navbarheightguess" id="hello" style={{height:this.state.insets.top, color: 'black'}} ref={this.spacerRef}></div>
                                        <Navbar
                                            className="color-nav"
                                            style={{
                                                paddingLeft: 12, paddingRight: 12, paddingTop: 0, paddingBottom: 8, minHeight: 54, border: '1px solid #ccc'
                                            }}
                                            bg="light"
                                            fixed="bottom"
                                            onToggle={this.toggle.bind(this)}
                                            ref={this.fixedMenuBarRef}
                                            >
                                                <Navbar.Collapse id="basic-navbar-nav ml-auto">
                                                <Nav className="w-100" style={{marginLeft: 'auto', marginRight:'auto'}}>
                                                    <div className="mobile-footer-nav-items d-flex flex-row justify-content-around w-100">
                                                    {routes.map((route, index) => ((route.hidden !== true) && (route.mobile === true) && (
                                                        <NavItem className="mobile-footer-nav-item" key={index}>
                                                            <Nav.Link
                                                                as={NavLink}
                                                                to={route.path}
                                                                className="nav-link mobile-footer-nav-link"
                                                                aria-label={route.name}
                                                                activeClassName="active"
                                                                style={{
                                                                    color: (route.path !== this.state.path)?'#aaa':'#026',
                                                                    paddingTop: 10,
                                                                    paddingBottom: 0,
                                                                    margin: 0
                                                                }}
                                                                onClick={
                                                                    () => {
                                                                        if (route.path !== this.state.path) {
                                                                            trackCustomEvent({
                                                                                ev: `nav.click.mobile.${route.path}`,
                                                                                unique: false,
                                                                            })
                                                                            this.setState({ path: route.path, expanded: !this.state.expanded });
                                                                            this.navLinkHandleClick.bind(this);
                                                                        }
                                                                    }
                                                                }
                                                                exact
                                                            >
                                                                <div className="row d-flex flex-column justify-content-center align-items-center" style={{
                                                                    padding: 0,
                                                                    maxHeight: '7vh'
                                                                }}>
                                                                    <route.TabIcon style={{
                                                                        maxHeight: '2.3vh'
                                                                    }}/>
                                                                    <div className="mobile-footer-nav-label">
                                                                        <span
                                                                            className={`mobile-footer-nav-label-default${route.mobileCompactName ? ' has-compact' : ''}`}
                                                                            aria-hidden="true"
                                                                        >
                                                                            {route.name}
                                                                        </span>
                                                                        {route.mobileCompactName ? (
                                                                            <span className="mobile-footer-nav-label-compact" aria-hidden="true">
                                                                                {route.mobileCompactName}
                                                                            </span>
                                                                        ) : null}
                                                                    </div>
                                                                </div>
                                                            </Nav.Link>
                                                        </NavItem>
                                                    )))}
                                                    </div>
                                                </Nav>
                                                </Navbar.Collapse>

                                                <div className="navbartogglezone">
                                                <Navbar.Toggle />
                                            </div>
                                        </Navbar>
                                        </>:<>
                                            <div className="navbarheightguess" id="hello" style={{height:this.state.insets.top, color: 'black'}} ref={this.spacerRef}></div>
                                            <div id="browsebar" style={{backgroundColor:'#F9F9F9'}}>
                                                <a href='/' style={{color:'#007', height:44, fontSize:16, padding:5}}>&nbsp;&lt;&lt;&nbsp;browse&nbsp;</a>
                                                {(window.history.length >= 1)?
                                                    <button onClick={() => window.history.back()} style={{color:'#007', border: 'none', backgroundColor:"#FFFF", height:32, fontSize:16, padding:5}}>&nbsp;&lt;&nbsp;back</button>
                                                    : null
                                                }
                                                {(window.history.length != 0)?
                                                    <button onClick={() => window.history.forward()} style={{color:'#007', border: 'none', backgroundColor:"#FFFF", height:32, fontSize:16, padding:5}}>&nbsp;&nbsp;forward&nbsp;&gt;</button>
                                                    : null
                                                }
                                            </div>
                                        </>}
                                    </>   
                                }

                                {/* <div style={{height:this.state.menuBarHeight, backgroundColor:"#F0F"}}>

                                </div> */}
                                
                                {isPrerender ? (
                                    <div className="example">
                                        {prerenderRoute ? <prerenderRoute.Component /> : null}
                                    </div>
                                ) : routes.map(({ path, Component }) => (
                                    <Route key={path} exact path={path} sensitive>
                                        {({ match }) => (

                                            <div className="example">
                                                {(match != null) ? <Component /> : null}
                                            </div>

                                        )}
                                    </Route>
                                ))}

                                {/* <Route key={"/blank"} exact path={"/blank"}>
                                        {({ match }) => (

                                            <div className="example">
                                                {(match != null) ? <PageBlank /> : null}
                                            </div>

                                        )}
                                </Route> */}
                                <Route path="/blank" element={<RouterOutlet />}>
                                    <Route index element={<PageBlank />} />
                                </Route>
                                <Route path="/raw" render={() => <RouterOutlet />} />
                            </Router>
                        </ThemeProvider>
                    </ThemeContext.Provider>
                </div>
                
                {/* <div style={{
                    position: 'absolute',
                    background: 'linear-gradient(165deg, #ececf1 -200%, #fdfdff 100%)',
                    top: 0,
                    left: 0,
                    minHeight: '100vh',
                    minWidth: '100vw',
                    zIndex: 3000,
                    pointerEvents: 'none',
                    opacity: this.state.loading ? 1 : 0,
                    display: this.state.loading ? '' : 'none',
                }}
                />
                <ModalLoader loading={this.state.loading} /> */}
                </AlertProvider>
                
            </div>
        );
    }
}

export { App };
